/**
 * Accès à l'API Nina.fm — seul module qui lit ces variables d'environnement.
 *
 * Aucun défaut ici : les valeurs de dev vivent dans `.env.development` et
 * `.env.test`, que le build de production ne charge pas. Un défaut dans le code
 * masquait l'absence de la variable et livrait la valeur de dev en prod (#81) :
 * une variable absente lève désormais une erreur qui la nomme.
 */

function requireEnv(name: string, value: string | undefined): string {
  if (!value) throw new Error(`Variable d'environnement manquante : ${name}`);
  return value;
}

// Accès littéral à `import.meta.env.X` : c'est la forme que Vite remplace au build
export const NINA_API_URL: string = requireEnv(
  'VITE_NINA_API_URL',
  import.meta.env.VITE_NINA_API_URL
);

/** Jeton public de lecture audio, attendu par l'API sur `/files/audio/` */
export const NINA_PUBLIC_TOKEN: string = requireEnv(
  'VITE_NINA_PUBLIC_TOKEN',
  import.meta.env.VITE_NINA_PUBLIC_TOKEN
);
